export default class EmailValidationTool {
  public static fromEmailValidation(value: string, provider: string | null): boolean | string {
    if (provider === 'SPARKPOST') {
      if (!value) {
        return 'FI From Email Address is required!';
      }

      if (!(/.+@.+\..+/.test(value))) {
        return 'Enter a valid FI From Email Address!';
      }
    }

    return true;
  }

  public static fromSfmcEmailValidation(value: string, provider: string | null): boolean | string {
    if (provider === 'SALESFORCE_MARKETING_CLOUD') {
      if (!value) {
        return 'FI From Email Sfmc Address is required!';
      }
    }

    return true;
  }
}
